// extracted by mini-css-extract-plugin
export default {"container":"VideoPlayer_container__0ND9Y","closeBtn":"VideoPlayer_closeBtn__D0fi8"};